import { Params } from 'react-router-dom'
import BlogPage from '../../pages/public/blogPage'
import FAQPage from '../../pages/public/faqPage'
import PublicHome from '../../pages/public/PublicHome'
import DiscoverLayout from '../../pages/auth/_layout/discoverLayout'
import profileScreen from '../../pages/auth/screens/profileScreen'
import upgradeScreen from '../../pages/auth/payment/upgradeScreen'
import CommunityGuidelines from '../../pages/public/legal/CommunityGuidelines'
import TermsAndConditions from '../../pages/public/legal/TermsAndCondition'
import PrivacyPolicy from '../../pages/public/legal/PrivacyPolicy'
import { permissions } from 'enums/PermissionEnums'
import { getBlog, getStory, getTipTrick } from '_services/blogs.service'
import StoryPost from '../../pages/public/_components/storyPost'
import SuccessStoryPage from '../../pages/public/successStoryPage'
import AddEditForm from '../../pages/auth/_forms/add_edit/add_edit'
import UserApproval from '../../pages/auth/screens/userApproval/userApproval'
import SystemScreen from '../../pages/auth/screens/userApproval/systemScreen'
import { Interactions } from '../contexts/interactions'
import FrequentDenialReasons from '../../pages/public/fdrPage'
import TipsAndTricks from '../../pages/public/tipsAndTricks'
import ErrorScreen from '../../pages/auth/screens/errorScreen'
import Unsubscribe from '../../pages/public/unsubscribe'
import Onboarding from '../../pages/auth/screens/onboarding/onboarding'

type Route<a> = {
  path:string
  component:(_:a) => React.ReactNode
  props:a & JSX.IntrinsicAttributes
}
type Route_ = <R>(cb:<a>(_:Route<a>) => R) => R
const mkRoute = <a>(x:Route<a>) : Route_ => cb => cb(x)

export const publicRoutes : Route_[] = [
  mkRoute({ path: '', component: PublicHome,props:{} }),
  // { path    : "/createUser",   component: UserSignup },

  mkRoute({ path: '/blog', component: BlogPage,props:{} }),
  mkRoute({ path: '/stories', component: SuccessStoryPage,props:{} }),
  mkRoute({ path: '/tips-tricks', component: TipsAndTricks,props:{} }),
  mkRoute({ path: '/faq', component: FAQPage,props:{} }),
  mkRoute({ path: '/frequent-denial-reasons', component: FrequentDenialReasons,props:{} }),
  mkRoute({ path: '/community-guidelines', component: CommunityGuidelines,props:{} }),
  mkRoute({ path: '/terms-and-conditions', component: TermsAndConditions,props:{} }),
  mkRoute({ path: '/privacy-policy', component: PrivacyPolicy,props:{} }),
  mkRoute({ path: '/blogPost/:id', component: StoryPost, props:{fetchStory:getBlog, renderStoryPhoto:true} }),
  mkRoute({ path: '/successStory/:id', component: StoryPost, props:{fetchStory:getStory, renderStoryPhoto:false} }),
  mkRoute({ path: '/tipTrick/:id', component: StoryPost, props:{fetchStory:getTipTrick, renderStoryPhoto:false} }),
  mkRoute({ path: '/unsubscribe/:id', component: Unsubscribe, props:{} }),
]

export const webNav = (auth:{ 'hasPermission':(_:string) => boolean,'hasPremium':boolean }) => [
  {
    'path':'discover',
    'title':'Discover',
  },
].concat(!auth.hasPremium ? [
  {
    'path':'upgrade',
    'title':'Upgrade',
  },
] : []).concat(auth.hasPermission(permissions.PhotoApproval) ? [
  {
    'path':'user-approval',
    'title':'User Approval',
  },
  {
    'path':'system-screen',
    'title':'System',
  }
] : [])


type MobileNavItem = {
  'path':string
  'title':string
  'icon':string
  'badge':(_:Interactions) => Promise<number | false>
}

export const mobileNav = (auth:{ 'hasPremium':boolean }) : MobileNavItem[] => [
  {
    'path':'discover',
    'title':'Discover',
    'icon':'pi pi-search',
    'badge':async (_:Interactions) => false as const,
  },
  {
    'path':'discover/likes',
    'title':'Likes Me',
    'icon':'pi pi-heart',
    'badge':async (x:Interactions) => {
      const [likes,seen] = await Promise.all([x.likes,x.seen])
      return likes.filter((x) => x.occurred.isAfter(seen.likes)).length
    },
  },
  {
    'path':'discover/messages',
    'title':'Chat',
    'icon':'pi pi-comments',
    'badge':async (x:Interactions) => {
      const [matches,conversations,seen] = await Promise.all([x.matches,x.conversations,x.seen])
      return Object.values(x.unread).filter((x) => !!x).length + matches.filter((x) => x.occurred.isAfter(seen.likes)).length
    }
  },
].concat(!auth.hasPremium ? [
  {
    'path':'upgrade',
    'title':'Upgrade',
    'icon':'pi pi-sparkles',
    'badge':async (_:Interactions) => false as const,
  }
  ]:[]
).concat([
  {
    'path':'profile',
    'title':'Profile',
    'icon':'pi pi-user',
    'badge':async (_:Interactions) => false as const,
  },
])

export const authRoutes = [
  {
    path: 'discover',
    component: DiscoverLayout,
    renderNav: true,
    replaced:(_:Readonly<Params<string>>) => `discover`,
  },
  {
    path: 'discover/:kind',
    component: DiscoverLayout,
    renderNav: true,
    replaced:(params:Readonly<Params<string>>) => `discover/${params.kind}`,
  },
  {
    path: 'discover/:kind/:userId',
    component: DiscoverLayout,
    renderNav: true,
    replaced:(params:Readonly<Params<string>>) => `discover/${params.kind}/${params.userId}`,
  },
  {
    path: 'user-approval',
    component: UserApproval,
    renderNav: true,
  },
  {
    path: 'system-screen',
    component: SystemScreen,
    renderNav: true,
  },
  {
    path: 'profile',
    component: profileScreen,
    renderNav: true,
  },
  {
    path: 'profile/:action',
    component: profileScreen,
    renderNav: true,
    replaced:(params:Readonly<Params<string>>) => `profile/${params.action}`,
  },
  {
    path: 'upgrade',
    component: upgradeScreen,
    renderNav: true,
  },
  {
    path: 'error',
    component: ErrorScreen,
    renderNav: true,
  },
  {
    path: 'onboarding',
    component: Onboarding,
    renderNav: false,
  },
]
